/** Ошибка API: нужна подписка (данные пользователя при этом не затрагиваются). */
export function isSubscriptionRequiredError(err: unknown): boolean {
  const response = (err as { response?: { code?: string } })?.response;
  return response?.code === 'SUBSCRIPTION_REQUIRED';
}
